import { FormBuilder, FormGroup } from '@angular/forms';
import { DailyReportService } from './../_services/daily-report.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-daily-report',
  templateUrl: './daily-report.component.html',
  styleUrls: ['./daily-report.component.scss'],
  providers: [DatePipe],
})
export class DailyReportComponent implements OnInit, OnDestroy {
  loading: boolean = true;
  data: any;
  subscriptions: Subscription[] = [];
  form: FormGroup;
  workScore = [];

  constructor(
    private dailyReportService: DailyReportService,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {}

  /* ====================================
    *              LIFECYCLES
    ======================================= */
  ngOnInit(): void {
    this.form = this.fb.group({
      date: [''],
    });

    this.calculateDateBeforetoday();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
  /* ====================================
    *             MAIN FEATURES
    ======================================= */
  getData(date) {
    this.workScore = [];

    this.loading = true;
    this.subscriptions.push(
      this.dailyReportService.getAll(date).subscribe((responseData) => {
        this.data = responseData;
        this.loading = false;

        this.data.workScore.header = 'Radni učinak';
        this.data.totalScore.header = 'Ukupni učinak';

        this.workScore.push(this.data.workScore);
        this.workScore.push(this.data.totalScore);
      })
    );
  }

  onSearch() {
    const form = this.form.getRawValue();
    const date = this.datePipe.transform(form.date, 'dd.MM.yyyy');

    this.getData(date);
  }

  onExportPdf() {
    const form = this.form.getRawValue();

    form.date = this.datePipe.transform(form.date, 'dd.MM.yyyy');

    this.subscriptions.push(
      this.dailyReportService.exportToPdf(form.date).subscribe((pdfHref) => {
        window.open(pdfHref.href, '_blank');
      })
    );
  }
  /* ====================================
   *             HELPERS
   ======================================= */
  clearFilters() {
    this.form.patchValue({
      date: '',
    });

    this.calculateDateBeforetoday();
  }

  calculateDateBeforetoday() {
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 1);

    const year = currentDate.getFullYear();
    const month = ('0' + (currentDate.getMonth() + 1)).slice(-2);
    const day = ('0' + currentDate.getDate()).slice(-2);

    const dayBeforeToday = `${day}.${month}.${year}`;

    this.getData(dayBeforeToday);
  }
}
